// extracted by mini-css-extract-plugin
module.exports = {"group-activity-box":"group-activity-box___3jxwN","group-activity-line":"group-activity-line___1jKtZ"};